import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-workup",
  templateUrl: "./dental-workup.component.html",
  styleUrls: ["./dental-workup.component.scss"],
})
export class DentalWorkupComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
